export default {
  loginPage: "login-page",
};
